import { render, staticRenderFns } from "./iconButtons.vue?vue&type=template&id=2816065c&scoped=true&"
import script from "./iconButtons.vue?vue&type=script&lang=ts&"
export * from "./iconButtons.vue?vue&type=script&lang=ts&"
import style0 from "./iconButtons.vue?vue&type=style&index=0&id=2816065c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2816065c",
  null
  
)

component.options.__file = "iconButtons.vue"
export default component.exports